import {isNil} from 'ramda';

import {Nullish} from 'shared/web';

export const getDecimalFromPercentage = (num: number | Nullish) => {
  if (isNil(num)) {
    return;
  }

  return Math.round(num * 100) / 10000;
};
